import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../utilis/api";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: ""
  });
  const [loading, setLoading] = useState(false);
  const [tokenValid, setTokenValid] = useState(true);
  
  const token = searchParams.get("token");
  const email = searchParams.get("email");

  useEffect(() => {
    if (!token) {
      setTokenValid(false);
      toast.error("Invalid reset link");
    }
  }, [token]);

  const inputStyle = {
    width: "100%",
    border: "1px solid #ddd",
    borderRadius: "10px",
    padding: "12px 16px",
    fontSize: "14px",
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    transition: "border-color 0.2s",
  };

  const goldBtn = {
    width: "100%",
    background: "#b38f36",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    padding: "14px",
    fontWeight: 700,
    fontSize: "16px",
    cursor: "pointer",
    marginTop: "16px",
    letterSpacing: "0.03em",
    transition: "background 0.2s",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!formData.password || !formData.confirmPassword) {
        toast.error("Please fill in all fields");
        return;
      }

      if (formData.password.length < 6) {
        toast.error("Password must be at least 6 characters");
        return;
      }

      if (formData.password !== formData.confirmPassword) {
        toast.error("Passwords do not match");
        return;
      }

      console.log("🔐 RESET PASSWORD REQUEST");
      console.log("🎫 Token:", token);
      console.log("🔑 New Password Length:", formData.password.length);
      
      const response = await api.post("/auth/reset-password", {
        token: token,
        password: formData.password,
        email: email || "user@example.com" // Fallback email for local development
      });

      if (response.data?.meta?.success) {
        console.log("✅ Password Reset Successful!");
        toast.success("Password reset successfully! Please login with your new password.");
        
        setTimeout(() => {
          navigate("/", { replace: true });
        }, 2000);
      } else {
        console.log("❌ Reset failed:", response.data?.meta?.message);
        toast.error(response.data?.meta?.message || "Failed to reset password");
      }

    } catch (error) {
      console.error("❌ Reset password error:", error);
      const message = error?.response?.data?.meta?.message || 
                     error?.response?.data?.message || 
                     error.message || 
                     "Failed to reset password. Please try again.";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  if (!tokenValid) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl p-8 w-full max-w-md text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-2xl">❌</span>
          </div>
          <h2 className="text-xl font-bold text-gray-800 mb-2">Invalid Reset Link</h2>
          <p className="text-gray-600 mb-6">This password reset link is invalid or has expired.</p>
          <button
            onClick={() => navigate("/")}
            className="w-full bg-[#b38f36] text-white py-3 rounded-lg font-semibold hover:bg-[#8e712a] transition-colors"
          >
            Go to Homepage
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-br from-[#e5cf94] to-[#b38f36] rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-2xl">🔐</span>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Reset Your Password</h2>
          <p className="text-gray-600">Enter your new password below</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase tracking-wide">
              New Password
            </label>
            <input
              type="password"
              style={inputStyle}
              placeholder="Enter new password"
              value={formData.password}
              onChange={(e) => setFormData(prev => ({ ...prev, password: e.target.value }))}
              onFocus={(e) => (e.target.style.borderColor = "#b38f36")}
              onBlur={(e) => (e.target.style.borderColor = "#ddd")}
              disabled={loading}
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase tracking-wide">
              Confirm Password
            </label>
            <input
              type="password"
              style={inputStyle}
              placeholder="Confirm new password"
              value={formData.confirmPassword}
              onChange={(e) => setFormData(prev => ({ ...prev, confirmPassword: e.target.value }))}
              onFocus={(e) => (e.target.style.borderColor = "#b38f36")}
              onBlur={(e) => (e.target.style.borderColor = "#ddd")}
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            style={{
              ...goldBtn,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? "not-allowed" : "pointer"
            }}
            onMouseEnter={(e) => !loading && (e.currentTarget.style.background = "#8e712a")}
            onMouseLeave={(e) => !loading && (e.currentTarget.style.background = "#b38f36")}
            disabled={loading}
          >
            {loading ? "Resetting Password..." : "Reset Password"}
          </button>
        </form>

        <div className="text-center mt-6">
          <button
            onClick={() => navigate("/")}
            className="text-[#b38f36] hover:text-[#8e712a] font-semibold text-sm"
          >
            ← Back to Homepage
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;